/* eslint-disable no-mixed-operators */
import {
  PropType, h, defineComponent, getCurrentInstance,
} from 'vue'
import { isEmpty } from 'lodash'
import businessTheme from '../../theme/businessTheme'
import { BeerCls, MemoBeerCls } from '../../core/ds/index'
import { BeerStyleObj } from '../../core'

interface BsSplitObj {
  cachedBs: BeerStyleObj
  restBs: BeerStyleObj
}

export default defineComponent({
  name: 'NewBsBox',
  props: {
    bs: {
      type: Object as PropType<BeerStyleObj>,
      default: () => ({}),
    },
    as: {
      type: [String, Object],
      default: 'div',
    },
    context: {
      type: Object,
      required: false,
    },
  },
  setup(props, { attrs, slots }) {
    const instance = getCurrentInstance()

    return () => {
      const { as: Component, bs, context } = props
      const { class: dataClass, ...restAttrs } = attrs || {}

      const classInterpolations: string[] = []
      const mergedProps = {
        ...(context || {
          ...(instance?.parent?.props || {}),
          ...(instance?.parent?.data || {}),
        }),
        theme: businessTheme,
      }

      const { cachedBs, restBs } = Object.keys(bs || {})
        .reduce((acc, k) => {
          if (k?.startsWith('cmp')) {
            acc.cachedBs[k] = bs[k]
          } else {
            acc.restBs[k] = bs[k]
          }
          return acc
        }, { cachedBs: {}, restBs: {} } as BsSplitObj)
      let cachedCls = ''
      let cls = ''
      if (!isEmpty(cachedBs)) {
        cachedCls = MemoBeerCls(
          cachedBs,
          mergedProps,
          true,
        )
      }
      if (!isEmpty(restBs)) {
        cls = BeerCls(
          // handling css specificity
          //  - dyn stand for dynamic
          // when there is cached, make bs rest props higher specificity
          cachedCls ? {
            '&.dyn': restBs,
          } : restBs,
          mergedProps,
          classInterpolations,
          true,
        )
      }
      const className = [
        cachedCls,
        cls,
        cachedCls && cls ? 'dyn' : undefined,
        // dataClass,
      ].filter(i => i)

      const passAttrs = restAttrs
      if (className.length > 0) {
        passAttrs.class = className
      }

      return h(
        Component,
        passAttrs,
        slots,
      )
    }
  },
})
